import { Box, Typography, Button } from '@mui/material';
import React from 'react';

interface Props {
    handleIsShowChampionsPassModal:(value:boolean)=>void
}

export default function ChampionsPassBanner({handleIsShowChampionsPassModal}:Props) {

 const userName = window?.pgUser?.first_name

  return (
    <Box sx={{
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        padding: '16px 12px',
        background: '#0AA89A',
        flex: 1
    }}>
      <Typography sx={{ 
        color: '#FFF', 
        fontFamily: 'Lato', 
        fontSize: '16px', 
        fontStyle: 'normal', 
        fontWeight: 400, 
        lineHeight: '110%', 
        flex: 1, 
        wordBreak: 'break-word', 
        marginRight: '4px'
      }}>
        <span style={{ fontWeight: 900 }}>{userName && userName+","}</span> Start Your Free Trial to Unlock All Courses
      </Typography>
      <Button 
          onClick={()=>{
            // handleIsShowChampionsPassModal(true)
            window.showChampionsPassPopupNoTimeout(null,"Chapmions Pass","Playlist Banner")
          }}
          variant="contained" sx={{ 
          backgroundColor: '#4362ED', 
          color: '#FFFFFF',
          fontSize: '16px',
          fontWeight: 900,
          textTransform: 'none', 
          width: '89px', 
          height: '35px',
          padding: 0,
          flexShrink: 0 ,
      }}>
        Start Trial
      </Button>
    </Box>
  );
}
